import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import ProductCard from "../product/ProductCard";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import Slider from "react-slick/lib";
import bg from '../../img/wall.jpg'
import H from "../typography/H";
import Button from "./Button";
import {mixins} from "../../mixins";

const HeaderWithAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  >*{
    &:last-child{
      flex-shrink: 0;
    }
  }
`;

const ProductSlider = styled(Slider)`
  margin-right: -10px;
  margin-left: -10px;
  .slick-list, .slick-track{
    display: flex;
    align-items: stretch;
  }
  .slick-track{
    padding: 15px 0 5px;
  }
  .slick-slide{
    padding: 0 10px;
    >*{
      height: 100%;
    }
  }
`;

const BG = styled.div`
  ${mixins.stretch()};
  z-index: -1;
  &:before{
    ${mixins.pseudoToBlock()};
    ${mixins.stretch()};
    ${mixins.fitBg()};
    background-image: url(${bg});
    opacity: 0.2;
  }
  &:after{
    ${mixins.pseudoToBlock()};
    /*${mixins.stretch()};*/
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-height: 500px;
    background: linear-gradient(0deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  }
`;

class FeaturedSection extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.dots = '';

        this.slider = React.createRef();
    }

    next() {
        this.slider.current.slickNext();
    }

    previous() {
        this.slider.current.slickPrev();
    }
    render() {

        const settings = {
            dots: true,
            infinite: true,
            speed: 300,
            arrows: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: 1,
            swipeToSlide: true,
            appendDots: dots => {
                this.dots = dots;
                //console.log(this);
                return <div/>
            },
        };
        const featured = this.props.featuredProducts.map((product, key) => {
            return <ProductCard key={key} product={product}/>
        });
        return (
            <section className={this.props.className}>
                <BG/>
                <div className={'container'}>
                    <HeaderWithAction>
                        <H size={2} styleSize={2}>
                            Смотрите популярные модели
                        </H>
                        <Button label={'Перейти в каталог'}/>
                    </HeaderWithAction>
                    <ProductSlider ref={this.slider} {...settings}>
                        {featured}
                    </ProductSlider>
                    <div style={{textAlign: "center"}}>
                        <button className="button" onClick={this.previous}>
                            Previous
                        </button>
                        {/*{this.dots}*/}
                        <button className="button" onClick={this.next}>
                            Next
                        </button>
                    </div>
                </div>
            </section>
        );
    };
}

function mapStateToProps(state) {
    const featuredProducts = state.get('products').filter((product) => product.get('featured'));
    return {
        featuredProducts: featuredProducts,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(FeaturedSection)`
  padding-top: 80px;
  position: relative;
`));